export default __webpack_public_path__ + "static/media/global-member-search-icon.5bc6a21d.svg";